import { createFileRoute, redirect } from "@tanstack/react-router";

/** Retired duplicate quiz library. Play is the single visitor quiz destination. */
export const Route = createFileRoute("/quizzes")({
  beforeLoad: () => {
    throw redirect({ to: "/play", statusCode: 301 });
  },
  component: () => null,
});
